var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Field__Component" }, [
    _c(
      "label",
      { staticClass: "Field__Component__Label", attrs: { for: "" } },
      [
        _c("span", [_vm._t("default")], 2),
        _c(
          "v-select",
          {
            key: _vm.data.length,
            attrs: {
              dir: "rtl",
              label: "Text",
              options: _vm.data,
              clearable: _vm.clearable,
              placeholder: "בחר ערך מהרשימה",
              reduce: function(item) {
                return item.Value
              },
              value: _vm.value
            },
            on: { input: _vm.setSelected }
          },
          [
            _c("div", { attrs: { slot: "no-options" }, slot: "no-options" }, [
              _vm._v("לא נמצאו ערכים דומים")
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }